import { z } from 'zod';
import { c } from '../../contract';
import { EnrichedLedgerEntrySchema, PointsBundle } from '../../types';

export const pointsRouter = c.router(
  {
    getPointsMap: {
      summary: 'Gets a mapping of package ID to points',
      method: 'GET',
      path: '/map',
      responses: {
        200: z.record(z.string(), z.array(PointsBundle)),
      },
      deprecated: true,
      description: 'use /paywall/map instead',
    },
    getEnrichedUserPointsLedger: {
      summary: 'Get user points transaction history with enriched data',
      method: 'GET',
      path: '/ledger',
      responses: {
        200: z.array(EnrichedLedgerEntrySchema),
      },
    },
  },
  { pathPrefix: '/points' },
);
